import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import CreateOdooProductForm from "./CreateOdooProductForm";

const FETCH_PRODUCT_FOR_ODOO = gql`
  query FETCH_PRODUCT_FOR_ODOO($id: ID!) {
    product(id: $id) {
      id
      odooId
      company
      name
      nameCn
      number
      countryCodeOfOrigin
      version
      itemWeight
      isLaborCost
      isSalable
      isPurchasable
      barCode: innerBoxBarcodeEan
      odooCategoryId
      productLine {
        id
        name
        hsCodeForEu
      }
      itemsPerSet
      defaultQty
      defaultSupplier {
        id
        odooId
        name
      }
      children {
        id
        product {
          id
          name
          number
          odooId
          suppliers {
            id
            useType
            supplier {
              id
            }
          }
          prices {
            id
            minQty
            price
            factory {
              id
              name
              odooId
            }
            archivedAt
          }
        }
        qty
      }
      activePrices {
        id
        company
        minQty
        currency
        price
        factory {
          id
          name
          odooId
        }
        archivedAt
      }
    }
  }
`;

const OdooProductFormLoader = ({ id, onCreated }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_FOR_ODOO, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <CreateOdooProductForm
      id={id}
      originalProduct={data.product}
      onCreated={onCreated}
    />
  );
};

export default OdooProductFormLoader;
